import { getScheduleTypes } from "@/services/schedules";
import { getGroupsProcedures, getProceduresTypes } from "@/services/unities";
import {
  getFilteredProcedures,
  getCountiesOfBahia,
  getHeathRegions,
  getMacroregions,
  getHealthDistricts,
} from "@/services/utilityService";
import { getPriorityClassification } from "@/services/solicitations";

export default {
  state: {
    solicitationData: {},

    regulatePatientFilters: {},
    filterData: {
      typeSolicitationData: [],
      groupData: [],
      procedurePPPData: [],
      priorityClassificationData: [],
      counties: [],
      healthRegions: [],
      macroregions: [],
      districts: [],
      procedureData: [],
    },
    regulateUNACONCACONFilters: {},
  },

  getters: {
    getRegulatePatientFilters: (state) => state.regulatePatientFilters,

    getRegulatePatientFilterTypeSolicitation: (state) =>
      state.filterData.typeSolicitationData,
    getRegulatePatientFilterGroup: (state) => state.filterData.groupData,
    getRegulatePatientFilterProcedurePPP: (state) =>
      state.filterData.procedurePPPData,
    getRegulatePatientFilterPriorityClassification: (state) =>
      state.filterData.priorityClassificationData,
    getRegulatePatientFilterCounties: (state) => state.filterData.counties,
    getRegulatePatientFilterHealthRegions: (state) =>
      state.filterData.healthRegions,
    getRegulatePatientFilterMacroregions: (state) =>
      state.filterData.macroregions,
    getRegulatePatientFilterDistricts: (state) => state.filterData.districts,
    getRegulatePatientFilterProcedure: (state) =>
      state.filterData.procedureData,
    getRegulateUNACONCACONFilters: (state) => state.regulateUNACONCACONFilters,

    getSolicitationDataForRegulation: (state) => state.solicitationData,
  },

  mutations: {
    setRegulatePatientFilters(state, data) {
      state.regulatePatientFilters = data;
    },

    setRegulateUNACONCACONFilters(state, data) {
      state.regulateUNACONCACONFilters = data;
    },

    setSolicitationDataForRegulation(state, data) {
      state.solicitationData = data;
    },

    async setRegulatePatientFilterData(state) {
      Promise.all([
        getScheduleTypes(),
        getProceduresTypes(),
        getGroupsProcedures(),
        getPriorityClassification(),
        getCountiesOfBahia(),
        getHeathRegions(),
        getMacroregions(),
        getHealthDistricts(),
      ]).then((requestResponse) => {
        state.filterData.typeSolicitationData = requestResponse[0].response;
        state.filterData.groupData = requestResponse[1].response;
        state.filterData.procedurePPPData = requestResponse[2].response;
        state.filterData.priorityClassificationData =
          requestResponse[3].response;
        state.filterData.counties = requestResponse[4].response.data;
        state.filterData.healthRegions = requestResponse[5].response.data;
        state.filterData.macroregions = requestResponse[6].response.data;
        state.filterData.districts = requestResponse[6].response.data;
      });

      const requestResponse = await getFilteredProcedures();
      state.filterData.procedureData = requestResponse.response.map((item) => {
        return {
          co_procedimento: item.co_procedure,
          no_procedimento: item.name_procedure,
        };
      });
    },
  },

  actions: {
    changeRegulatePatientFilters(context, filters) {
      context.commit("setRegulatePatientFilters", filters);
    },

    changeRegulatePatientFilterData(context) {
      context.commit("setRegulatePatientFilterData");
    },

    changeSolicitationDataForRegulation(context, data) {
      context.commit("setSolicitationDataForRegulation", data);
    },

    changeRegulateUNACONCACONFilters(context, filters) {
      context.commit("setRegulateUNACONCACONFilters", filters);
    },
  },
};
